import React, { useState, useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import { Link } from 'react-router-dom';
import { fetchAllGalleries } from '../../Services/GalleryService';
import Image from '../Image';

const GalleryCarousel = () => {
  const [galleries, setGalleries] = useState([]);


  const getImages = async () => {
    await fetchAllGalleries(setGalleries);
  }

  useEffect(() => {
    if(galleries.length === 0){
    getImages();
    }
  }, [galleries]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

  return (
    <div className="w-full max-w-7xl mx-auto ">
      <Carousel
        responsive={responsive}
        autoPlay={true}
        autoPlaySpeed={2500}
        infinite={true}
        showDots={false}
        arrows={false}
        className="relative"
        containerClass="carousel-container"
        itemClass="carousel-item-padding-700px"
        ssr={true}
      >
        {galleries && galleries.map((image, index) => (
          <div key={index} className="p-1">
            <div className="h-60 w-100 mx-auto rounded-lg overflow-hidden ">
            <Link to= "/gallery">  <Image id = {image.file_id} className="w-full h-full object-cover" /></Link> 
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );

};

export default GalleryCarousel;